import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>  //PURPOSE IS TO HELP TEST WE RUN FINE WITH CONCURRENT FEATURES, BUT CAN DOUBLE RENDER COMPONENTS, IM UNSURE WHY THIS IS USEFUL BUT THINK MORE ABOUT IT LATER
  //   <App />
  // </React.StrictMode>
  <App />,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
